import React from "react";
import { formatDateTimeNoSeconds } from "../../utils/dateTime";

function AttachmentListSection({
  attachments = [],
  onDownloadAttachment,
  heading = "Bilagor",
}) {
  if (!attachments.length) {
    return null;
  }

  return (
    <div className="ids-mb-6">
      <h3 className="ids-heading-s ids-mb-2">{heading}</h3>
      <ul>
        {attachments.map((att) => (
          <li key={att.id} style={{ marginBottom: "0.25rem" }}>
            <button
              type="button"
              onClick={() => onDownloadAttachment(att)}
              style={{
                background: "none",
                border: "none",
                color: "var(--ids-palette-primary-40)",
                cursor: "pointer",
                textDecoration: "underline",
                padding: 0,
              }}
            >
              {att.fileName}
            </button>
            <span style={{ color: "var(--ids-palette-neutral-50)", marginLeft: "0.5rem" }}>
              ({(att.fileSize / 1024).toFixed(0)} KB)
              {att.createdAt && ` · Uppladdad ${formatDateTimeNoSeconds(att.createdAt)}`}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default AttachmentListSection;